import { alignLeft as alignLeft_1 } from './alignLeft.locstring.json';
import loc from 'owa-localize';
import RibbonButton from './RibbonButton';

import { Alignment } from 'roosterjs-editor-types';
import { setAlignment } from 'roosterjs-editor-api';

const alignLeft: RibbonButton = {
    key: 'alignLeft',
    title: () => loc(alignLeft_1),
    imageSrc: require('../svg/alignleft.svg'),
    onExecute: (plugin, logUsage) => {
        setAlignment(plugin.getEditor(), Alignment.Left);
        logUsage('setAlignment', Alignment.Left);
    },
};

export default alignLeft;
